module.exports = __webpack_public_path__ + "img/practical-go-lessons-book4.16cc3f1d.jpg";